/** Shared website header: existing CMS mega-menu data, with desktop and mobile disclosures. */
export function familyMenu() {
  const header = document.querySelector('[data-family-header]');
  if (!header) return;
  const toggle = header.querySelector('[data-family-menu-toggle]');
  const menu = header.querySelector('#family-mobile-menu');
  const backdrop = document.querySelector('[data-family-nav-backdrop]');
  if (!toggle || !menu) return;
  const desktop = window.matchMedia('(min-width: 1024px)');
  const hover = window.matchMedia('(hover: hover)');
  let mobileOpen = false;
  let activeMega = null;
  let openedByHover = false;
  let closeTimer;

  const visibleLinks = (container) => [...container.querySelectorAll('a[href], button:not([disabled])')]
    .filter(element => element.getClientRects().length && !element.closest('[hidden]'));

  function syncBackdrop() {
    if (backdrop) backdrop.hidden = !(mobileOpen || (desktop.matches && activeMega));
  }

  function closeMega(restoreFocus = false) {
    clearTimeout(closeTimer);
    if (!activeMega) return;
    const item = activeMega;
    activeMega = null;
    openedByHover = false;
    item.classList.remove('is-mega-open');
    const trigger = item.querySelector('[data-family-mega-trigger]');
    trigger.setAttribute('aria-expanded', 'false');
    document.getElementById(trigger.getAttribute('aria-controls')).hidden = true;
    if (restoreFocus) trigger.focus();
    syncBackdrop();
  }

  function openMega(item, focusFirst = false, fromHover = false) {
    clearTimeout(closeTimer);
    if (activeMega !== item) closeMega();
    activeMega = item;
    openedByHover = fromHover;
    const trigger = item.querySelector('[data-family-mega-trigger]');
    const panel = document.getElementById(trigger.getAttribute('aria-controls'));
    trigger.setAttribute('aria-expanded', 'true');
    item.classList.add('is-mega-open');
    panel.hidden = false;
    if (focusFirst) visibleLinks(panel)[0]?.focus();
    syncBackdrop();
  }

  function setMobileOpen(value, restoreFocus = false) {
    closeMega();
    mobileOpen = value;
    toggle.setAttribute('aria-expanded', String(value));
    menu.hidden = !value;
    header.classList.toggle('is-open', value);
    if (value) visibleLinks(menu)[0]?.focus();
    if (restoreFocus) toggle.focus();
    syncBackdrop();
  }

  header.querySelectorAll('[data-family-mega-item]').forEach(item => {
    const trigger = item.querySelector('[data-family-mega-trigger]');
    const isDesktopItem = !!item.closest('.family-header__desktop');
    trigger.addEventListener('click', event => {
      event.preventDefault();
      activeMega === item && !openedByHover ? closeMega() : openMega(item);
    });
    trigger.addEventListener('keydown', event => {
      if (event.key === 'ArrowDown' || event.key === ' ') {
        event.preventDefault();
        openMega(item, true);
      }
    });
    item.addEventListener('pointerenter', () => {
      if (isDesktopItem && desktop.matches && hover.matches && activeMega !== item) openMega(item, false, true);
    });
    item.addEventListener('pointerleave', () => {
      if (!isDesktopItem || !desktop.matches) return;
      closeTimer = setTimeout(() => {
        if (activeMega === item && !item.contains(document.activeElement)) closeMega();
      }, 140);
    });
    item.addEventListener('focusout', event => {
      if (isDesktopItem && activeMega === item && !item.contains(event.relatedTarget)) closeMega();
    });
  });

  toggle.addEventListener('click', () => setMobileOpen(!mobileOpen));
  menu.addEventListener('click', event => {
    if (event.target.closest('a[href]:not([data-family-mega-trigger])')) setMobileOpen(false);
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      if (activeMega) { event.preventDefault(); closeMega(true); }
      else if (mobileOpen) { event.preventDefault(); setMobileOpen(false, true); }
      return;
    }
    if (event.key !== 'Tab' || !mobileOpen) return;
    const elements = [toggle, ...visibleLinks(menu)];
    const first = elements[0];
    const last = elements[elements.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
  document.addEventListener('click', event => {
    if (!header.contains(event.target)) {
      closeMega();
      if (mobileOpen) setMobileOpen(false);
    }
  });
  desktop.addEventListener('change', () => {
    closeMega();
    if (mobileOpen) setMobileOpen(false);
  });
}
